import React from 'react';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import { ModalComponent } from '../../../ui/modals/Modal/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import { DEFAULT_BOTTOM_MODAL_STYLE_CONFIG, DEFAULT_MODAL_STYLE_CONFIG } from '../../../ui/modals/Modal/config/index.js';

const TwoFactorAuthModal = ({
  isOpen,
  onClose,
  children,
  afterOpenModal = () => {
  },
  onAfterClose = () => {
  },
  title = "Two-Factor Autentification"
}) => {
  const { isMobile } = useWindowSize();
  return /* @__PURE__ */ React.createElement(
    ModalComponent.Modal,
    {
      modalIsOpen: isOpen,
      closeModal: () => onClose(),
      hideCloseButton: true,
      title,
      withWrapper: true,
      mobileWrapperV2: true,
      bottom: true,
      afterOpenModal,
      onAfterClose,
      configuration: isMobile ? DEFAULT_BOTTOM_MODAL_STYLE_CONFIG() : DEFAULT_MODAL_STYLE_CONFIG()
    },
    children
  );
};
TwoFactorAuthModal.displayName = "TwoFactorAuthModal";

export { TwoFactorAuthModal };
//# sourceMappingURL=index.js.map
